import React, { useState, useContext, useEffect } from 'react';
import { Wrap, WrapInput, WrapList } from '../../components/Wrap';
import { LabelInput, inputStyle,multSelect } from '../../components/Input';
import { SearchBox, IconeSearch, ItemsSearch } from "../../components/Search";
import { Button, CancelarBtn } from "../../components/Button";
import { Container, TitleStyle2,Items} from './styles'
import { HeaderList, BodyList } from '../../components/TabelaCadastro';
import { Modal, CircularProgress } from "@material-ui/core";
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AddIcon from '@material-ui/icons/Add';
import { Table, TableBody, TableCell, TableHead, TableRow, TableContainer } from '../../components/SharedComponents/table';
import { shade } from 'polished'
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { ThemeContext } from 'styled-components';
import { ERRORMESSAGE, SUCCESSMESSAGE, INFOMESSAGE } from '../../utils/types-messages';
import { useSnackbar } from 'notistack';
import { api } from '../../services/axios';
import { makeStyles } from '@material-ui/core/styles';
import { modalClose, ModalBox, StyledBox } from '../../components/Modal';
import CancelIcon from '@material-ui/icons/Cancel';
import MessageAlert from '../../components/MessageAlert';
import { useShowModal } from '../../contexts/SharedContext'
import { MySelect } from "../../components/InputSelect";
import InputMask from 'react-input-mask';
import Header from "../../components/Header"

export default function CadastroPessoaArea(props){
      const { enqueueSnackbar } = useSnackbar();
      const { colors, textTableColor } = useContext(ThemeContext);
      const [pessoasArea, setPessoasArea] = useState([]);
      const [anoConsulta, setAnoConsulta] = useState('');
      const [areaConsulta, setAreaConsulta] = useState('');
      const [loadDialog, setLoadDialog] = useState(false);
      const { setShowModalArea, showModalArea } = useShowModal();
      const [areaOptions, setAreaOptions] = useState([]);
      const [funcao, setFuncao] = useState(null);
      const [pessoa, setPessoa] = useState(null);
      const [pessoaOptions, setPessoaOptions] = useState([]);

      const useStyles = makeStyles({
          wrapBtnModal: {
            alignItems: 'flex-start'
          },
          containerModal: {
            boxShadow: '0px 4px 0px 0px rgba(0, 0, 0, 0)',
            borderRadius: '0'
          },
          headColModal: {
            backgroundColor: colors.surface,
            textTransform: 'uppercase',
            borderRadius: '0',
            fontSize: '14px'
          }
      });
      const classes = useStyles();

      const funcaoOptions = [
        { value: "Voluntário", label: "Voluntário" },
        { value: "Instrutor", label: "Instrutor" },
        { value: "Monitor", label: "Monitor" },
        { value: "Coordenador", label: "Coordenador" },
        { value: "Dirigente", label: "Dirigente" },
        { value: "Presidente", label: "Presidente" },
        { value: "Vice-Presidente", label: "Vice-Presidente" },
        { value: "Suplente", label: "Suplente" },
      ]

      const handleAreaConsulta = (item) => {
        setAreaConsulta(item);
      }

      const handlePessoa = (item) => {
        setPessoa(item);
      }

      const handleFuncao = (item) => {
        setFuncao(item);
      }

      useEffect(() => {
        getAreas();
      }, [])

      async function getAreas() {
        try {
            const { data } = await api.get(`area`);
            setAreaOptions(data);
        } catch (error) {
            enqueueSnackbar("Erro ao buscar Areas", ERRORMESSAGE);
        }
    }

    const getPessoasParaArea = async () => {
      try {
        setLoadDialog(true);
        const { data } = await api.get('/pessoaarea/pessoasparaarea?idArea='+areaConsulta.value+"&anoAtuacao="+anoConsulta);
        setPessoaOptions(data);
        setLoadDialog(false);
      } catch (err) {
        enqueueSnackbar("Erro ao buscar pessoas", ERRORMESSAGE);
        setLoadDialog(false);
      }
    }

    async function fetchSearch(showSnack=true) {
        try {
            let params = ''
            if ((anoConsulta === '') || (areaConsulta === null) || (areaConsulta.value === undefined) || (areaConsulta.value === '')) {
              enqueueSnackbar("Informe a Área e o Ano de Atuação!", ERRORMESSAGE);
            }
            else {
              if (showSnack) {const key = enqueueSnackbar('Pesquisando Pessoas da Área ...', INFOMESSAGE);};
              params += `&anoAtuacao=${anoConsulta}`
              params += `&idArea=${areaConsulta.value}`
              setLoadDialog(true);
              const { data } = await api.get(`pessoaarea?` + params);
              setPessoasArea(data);
              setLoadDialog(false);
            }
        } catch (error) {
            enqueueSnackbar("Erro ao buscar Pessoas da Área", ERRORMESSAGE);
            setLoadDialog(false);
        }
    }

    function clearSearch() {
        setPessoasArea([]);
        setAnoConsulta('');
        setAreaConsulta([]);
    }

    function clearInclude() {
      setPessoa([]);
      setFuncao([]);
    }

    function openModal(action, item) {
      if ((anoConsulta === '') || (areaConsulta === null) || (areaConsulta.value === undefined) || (areaConsulta.value === '')) {
        enqueueSnackbar("Informe a Área e o Ano de Atuação!", ERRORMESSAGE);
      }
      else {
        clearInclude();
        getPessoasParaArea();
        if (action === "insert") {
            setShowModalArea({ show: true, title: 'INCLUIR PESSOA NA ÁREA', action: 'inserir' });
        }
        else {
            setShowModalArea({ show: true, title: 'ALTERAR PESSOA DA ÁREA', action: 'editar', item: item });
        }
      }            
    }

    
    const handleClose = () => {
        setShowModalArea({ show: false });
      };

    async function sendPessoaArea() {

        const key = enqueueSnackbar('Cadastrando Pessoa na Área ...', INFOMESSAGE);
        
        try {
    
          const valoresInseridos = {
            idArea: areaConsulta.value,
            idPessoa: pessoa.value,
            anoAtuacao: anoConsulta,
            funcao: funcao.value
          };
    
          setLoadDialog(true);
          const { data } = await api.post("/pessoaarea/", valoresInseridos);
          if (data.message!=null) throw {message: data.message}
          enqueueSnackbar(<MessageAlert message={"Dados salvos com sucesso!"} />, SUCCESSMESSAGE);
          setShowModalArea({ show: false });
          fetchSearch(false);
          setLoadDialog(false);
        } catch (err) {
          enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE);
          setLoadDialog(false);
        }
      };
    
      async function editPessoaArea(id) {
    
        const key = enqueueSnackbar('Alterando Pessoa na Área ...', INFOMESSAGE);
    
        try {
    
          const valoresEditados = {
            anoAtuacao: anoConsulta,
            funcao: funcao.value
          };
    
          setLoadDialog(true);
          const { data } = await api.put("/pessoaarea/" + areaConsulta.value + "/" + pessoa.value, valoresEditados);
          if (!data.success) throw {message: data.message}
          enqueueSnackbar(<MessageAlert message={"Dados salvos com sucesso!"} />, SUCCESSMESSAGE);
          setShowModalArea({ show: false });
          fetchSearch(false);
          setLoadDialog(false);
    
        } catch (err) {
          enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE);
          setLoadDialog(false);
        }
      };

      useEffect(() => {
        if (showModalArea.action === 'editar') {
            setPessoa({value:`${showModalArea.item.idPessoa}`, label:`${showModalArea.item.nomePessoa}`});
            setFuncao({value:`${showModalArea.item.funcao}`, label:`${showModalArea.item.funcao}`});
        }
      }, [showModalArea.action])


    async function deletePessoaArea(item) {
        try {
          var resposta = window.confirm("Deseja remover esse registro?");
          if (resposta) {
            const key = enqueueSnackbar('Excluindo Pessoa da Área ...', INFOMESSAGE);
            const { data } = await api.delete("/pessoaarea/" + item.idArea + "/"+ item.idPessoa);
            if ((data.success !== undefined) && (!data.success))
            {
              throw new Error(data.message)
            }
            enqueueSnackbar(<MessageAlert message={"Pessoa excluída com sucesso!"} />, SUCCESSMESSAGE);
            fetchSearch(false);
          }
        } catch (err) {
          enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE);
        }
    };
    

    const bodyPessoaArea = (
        <StyledBox className={'disableFocus alert-modal'}>
          <TitleStyle2>
            {showModalArea.title}
            <CancelIcon
              style={modalClose}
              color={colors.error}
              size="20"
              title="Fechar"
              onClick={() => handleClose()}
            />
          </TitleStyle2>
          <ModalBox>
            <Wrap>
              <WrapInput style={{ position: 'relative', width: '30%'}}>
                <LabelInput>Pessoa <span style={{ color: '#FF0000' }}>*</span></LabelInput>
                <MySelect
                  styles={multSelect}
                  placeholder={'Opções...'}
                  value={pessoa}
                  isClearable={true}
                  isSearchable={true}
                  onChange={handlePessoa}
                  options={pessoaOptions.map((item) => { return { value: item.id, label: item.nome}; })}
                />
              </WrapInput>
            </Wrap>
            <Wrap>
              <WrapInput style={{ position: 'relative', width: '30%'}}>
                <LabelInput>Função <span style={{ color: '#FF0000' }}>*</span></LabelInput>
                <MySelect
                  styles={multSelect}
                  placeholder={'Opções...'}
                  value={funcao}
                  isClearable={true}
                  isSearchable={true}
                  onChange={handleFuncao}
                  options={funcaoOptions}
                />
              </WrapInput>
            </Wrap>
            <Wrap>
              <WrapInput className="wrapInputModal">
                <Items>
                  <CancelarBtn type="button" onClick={handleClose}> Cancelar </CancelarBtn>
                  <Button type="button" onClick={() => showModalArea.action === 'inserir' ? sendPessoaArea() : editPessoaArea()} > Salvar </Button>
                </Items>
              </WrapInput>
            </Wrap>
          </ModalBox>
        </StyledBox>
      );
    

    const modalLoad = (
        <div className={'disabeFocus alert-modal'}>
            <WrapInput className="alertText" style={{ alignItems: 'center' }}>
            <CircularProgress style={{ color: '#043D5D' }} /> <h3>Carregando...</h3>
            </WrapInput>
        </div>
    );

    return (
        <Container>
          <Header/>
            <Modal open={showModalArea.show}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
            {bodyPessoaArea}
            </Modal>
            <SearchBox style={{ margin: '20px 0 20px 0' }}>
                <TitleStyle2>Pesquisa de Pessoas da Área</TitleStyle2>
                <Wrap>
                <WrapInput style={{ width: '20%', paddingRight: '1px' }}> <LabelInput> Área <span style={{ color: '#FF0000' }}>*</span></LabelInput>
                  <MySelect
                    styles={multSelect}
                    placeholder={'Selecione a Área...'}
                    value={areaConsulta}
                    isClearable={true}
                    isSearchable={true}
                    onChange={handleAreaConsulta}
                    options={areaOptions.map((item) => { return { value: item.id, label: item.nome }; })}
                  />
                </WrapInput>
                <WrapInput style={{ width: '8%', paddingRight: '5px' }}> <LabelInput> Ano <span style={{ color: '#FF0000' }}>*</span> </LabelInput>
                <InputMask
                    mask="9999"
                    maskChar=""
                    placeholder="Informe o Ano"
                    style={inputStyle}
                    type="text"
                    name="anoConsulta"
                    onChange={e => setAnoConsulta(e.target.value)}
                    value={anoConsulta}
                  />
                </WrapInput>
                <WrapInput style={{ width:'60%', marginTop: '10px' }}>
                    <ItemsSearch>
                    <IconeSearch size={25} title="Pesquisar" onClick={() => fetchSearch(true)} />
                    <Button style={{ backgroundColor: '#3FC248' }} className='widthButton' onClick={() => openModal('insert')}>&nbsp;Novo<AddIcon></AddIcon></Button>
                    <Button className='widthButton' onClick={() => clearSearch()}>&nbsp;Limpar<DeleteOutlineIcon></DeleteOutlineIcon></Button>
                    </ItemsSearch>
                </WrapInput>
                </Wrap>
            </SearchBox>
            <WrapList>
                <HeaderList>
                <span style={{ marginLeft: '20px' }}> PESSOAS DA ÁREA</span>
                </HeaderList>
                {
                <BodyList>
                    <TableContainer>
                        <Table style={{ backgroundColor: colors.surface, width: '100%' }} className={classes.table} size="small">
                            <TableHead>
                            <TableRow>
                                <TableCell className={classes.head} style={{ color: textTableColor, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center">NOME</TableCell>
                                <TableCell className={classes.head} style={{ color: textTableColor, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center">FUNÇÃO</TableCell>
                                <TableCell className={classes.head} style={{ color: textTableColor, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center">ANO</TableCell>
                                <TableCell className={classes.head} style={{ color: textTableColor, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center">AÇÕES</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody style={{ width: '100%' }}>
                            {
                                pessoasArea && pessoasArea.map((row, index) => {
                                return (
                                    <TableRow style={{ backgroundColor: index % 2 === 0 ? shade(0.1, colors.surface) : '' }} key={index}>
                                        <TableCell style={{ color: textTableColor, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">{row.nomePessoa}</TableCell>
                                        <TableCell style={{ color: textTableColor, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">{row.funcao}</TableCell>
                                        <TableCell style={{ color: textTableColor, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">{row.anoAtuacao}</TableCell>
                                        <TableCell
                                            style={{ color: textTableColor, border: 'none', display: 'flex', justifyContent: 'center' }}
                                            align="center">
                                            <AiOutlineEdit
                                            onClick={() => openModal('update',row)}
                                            style={{ cursor: "pointer", marginLeft: '5px'  }}
                                            color={colors.primary}
                                            size="22"
                                            title="Editar"
                                            />          
                                            <AiOutlineDelete
                                            onClick={() => deletePessoaArea(row)}
                                            style={{ cursor: "pointer", marginLeft: '5px'  }}
                                            color={colors.primary}
                                            size="22"
                                            title="excluir"
                                            />                
                                        </TableCell>
                                    </TableRow>
                                    )
                                    })
                                }
                                </TableBody>
                        </Table>
                    </TableContainer >
 
                </BodyList>  
                }
            </WrapList>
            <Modal open={loadDialog}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {modalLoad}
            </Modal>
        </Container>
    )
}